(() => {
  const configNode = document.getElementById('emma-halloween-gift-config');
  if (!configNode || window.emmaHalloweenGift) return;
  const config = JSON.parse(configNode.textContent);
  const eligible = new Set(config.eligible.map(String));
  const giftVariant = String(config.variant);
  const startsAt = Date.parse(config.startsAt);
  const endsAt = Date.parse(config.endsAt);
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let queue = Promise.resolve();
  let resumingCheckout = false;
  let lastCart = null;
  let finished = false;
  let campaignLive = true;
  let observer;
  const active = () => campaignLive && Date.now() >= startsAt && Date.now() < endsAt;
  const enqueue = task => {
    const result = queue.then(task, task);
    queue = result.catch(() => {});
    return result;
  };
  const request = async (path, body) => {
    const response = await nativeFetch(root + path, body === undefined
      ? {headers: {Accept: 'application/json'}, cache: 'no-store', credentials: 'same-origin'}
      : {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
    if (!response.ok) throw new Error('Halloween gift cart update failed');
    return response.json();
  };
  const giftLines = cart => cart.items.filter(item => String(item.variant_id) === giftVariant);
  const qualifies = cart => active() && cart.items.some(item => eligible.has(String(item.product_id)) && item.quantity > 0 && !item.selling_plan_allocation && item.original_line_price > 0);
  const paint = cart => {
    const banner = document.getElementById('emma-halloween-gift-banner');
    if (banner) banner.hidden = !active();
    document.documentElement.classList.toggle('emma-halloween-gift-active', active());
    const hasGift = cart && giftLines(cart).some(item => item.final_line_price === 0);
    document.querySelectorAll('cart-items-component').forEach(component => {
      let note = component.querySelector('[data-emma-halloween-note]');
      if (!active()) {
        note?.remove();
        return;
      }
      if (!note) {
        note = document.createElement('p');
        note.dataset.emmaHalloweenNote = '';
        note.setAttribute('role', 'status');
        note.className = 'emma-halloween-gift-note';
        component.prepend(note);
      }
      const message = hasGift ? config.added : config.pending;
      if (note.textContent !== message) note.textContent = message;
    });
  };
  const reconcile = async () => {
    let cart = await request('cart.js');
    try {
      const product = await request('products/' + config.handle + '.js');
      campaignLive = product.available;
    } catch { campaignLive = false; }
    const currentCodes = (cart.discount_codes || []).map(entry => entry.code).filter(Boolean);
    if (active() && !currentCodes.some(code => code.toUpperCase() === config.code)) {
      cart = await request('cart/update.js', {discount: config.code});
    } else if (!active() && currentCodes.some(code => code.toUpperCase() === config.code)) {
      cart = await request('cart/update.js', {discount: ''});
    }
    let gifts = giftLines(cart);
    const desired = qualifies(cart) ? 1 : 0;
    let changed = false;
    const updates = {};
    gifts.forEach((item, index) => {
      const quantity = desired && index === 0 ? 1 : 0;
      if (quantity !== item.quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) {
      cart = await request('cart/update.js', {updates});
      changed = true;
    }
    if (desired && gifts.length === 0) {
      await request('cart/add.js', {items: [{id: config.variant, quantity: 1, properties: {_emma_halloween_gift: '2026-11-01-first10', 'Cocada flavor': config.flavor}}]});
      cart = await request('cart.js');
      changed = true;
    }
    gifts = giftLines(cart);
    const charged = gifts.filter(item => item.final_line_price > 0);
    if (charged.length) {
      cart = await request('cart/update.js', {updates: Object.fromEntries(charged.map(item => [item.key, 0]))});
      changed = true;
    }
    lastCart = cart;
    paint(cart);
    return {cart, changed};
  };
  const sectionsFor = data => Object.keys(data?.sections || {}).slice(0, 5);
  const refresh = async cart => {
    const components = [...document.querySelectorAll('cart-items-component')];
    const sections = [...new Set(components.map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
    if (sections.length) {
      const data = await request('cart/update.js', {updates: {}, sections, sections_url: location.pathname});
      const {morphSection} = await import('@theme/section-renderer');
      for (const [id, html] of Object.entries(data.sections || {})) {
        if (html) morphSection(id, html, {mode: 'hydration'});
      }
    }
    const {CartLinesUpdateEvent} = await import('@shopify/events');
    document.dispatchEvent(new CartLinesUpdateEvent({action: 'update', context: 'cart', lines: [], promise: Promise.resolve({cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {source: 'emma-halloween-gift', items: cart.items, itemCount: cart.item_count}})}));
    paint(cart);
  };
  window.fetch = function(input, init) {
    if (finished) return nativeFetch(input, init);
    let url;
    try {url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);} catch {return nativeFetch(input, init);}
    const method = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const isMutation = url.origin === location.origin && method === 'POST' && /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
    if (!isMutation) return nativeFetch(input, init);
    return enqueue(async () => {
      const response = await nativeFetch(input, init);
      if (!response.ok) return response;
      try {
        const data = await response.clone().json();
        const result = await reconcile();
        if (!result.changed) return response;
        const sections = sectionsFor(data);
        const updated = sections.length ? await request('cart/update.js', {updates: {}, sections, sections_url: location.pathname}) : result.cart;
        const isAdd = /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
        const body = isAdd ? {...data, ...(updated.sections ? {sections: updated.sections} : {})} : {...data, ...updated};
        const headers = new Headers(response.headers);
        headers.delete('content-length');
        headers.set('Content-Type', 'application/json');
        return new Response(JSON.stringify(body), {status: response.status, statusText: response.statusText, headers});
      } catch (error) {
        console.warn('[Halloween gift]', error.message);
        return response;
      }
    });
  };
  const settle = async () => {
    const result = await enqueue(reconcile);
    if (result.changed) await refresh(result.cart);
    return result;
  };
  const start = () => {
    const style = document.createElement('style');
    style.textContent = '.emma-halloween-gift-banner{background:#3a1748;color:#fff5db;text-align:center;padding:12px 18px;font:600 14px/1.5 sans-serif}.emma-halloween-gift-banner[hidden]{display:none}.emma-halloween-gift-note{background:#fff3da;color:#401b4d;border:1px solid #edb654;border-radius:10px;padding:12px;margin:10px 0;font-size:14px;line-height:1.5}.emma-halloween-gift-active product-form-component .shopify-payment-button,.emma-halloween-gift-active product-form-component shopify-accelerated-checkout{display:none!important}';
    document.head.append(style);
    const banner = document.createElement('aside');
    banner.id = 'emma-halloween-gift-banner';
    banner.className = 'emma-halloween-gift-banner';
    banner.setAttribute('aria-label', 'Día de los Angelitos');
    banner.textContent = config.banner;
    banner.hidden = !active();
    document.body.prepend(banner);
    paint(null);
    observer = new MutationObserver(() => paint(lastCart));
    observer.observe(document.body, {childList: true, subtree: true});
    const stop = () => {
      finished = true;
      observer.disconnect();
      paint(lastCart);
    };
    const remaining = endsAt - Date.now();
    if (remaining > 0) {
      settle().catch(error => console.warn('[Halloween gift]', error.message));
      setTimeout(() => settle().catch(error => console.warn('[Halloween gift]', error.message)).finally(stop), remaining + 50);
    } else if (config.initialCount > 0) {
      settle().catch(error => console.warn('[Halloween gift]', error.message)).finally(stop);
    } else stop();
  };
  document.addEventListener('submit', event => {
    if (finished || event.defaultPrevented || resumingCheckout || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin) return;
    if (/\/cart\/add\/?$/.test(action.pathname)) {
      event.preventDefault();
      window.fetch(action.pathname + '.js', {method: 'POST', body: new FormData(form)}).then(response => {
        if (!response.ok) throw new Error('Cart add failed');
        location.assign(root + 'cart');
      }).catch(() => location.assign(root + 'cart'));
    } else if (event.submitter?.name === 'checkout') {
      event.preventDefault();
      settle().then(() => {
        resumingCheckout = true;
        form.requestSubmit(event.submitter);
        resumingCheckout = false;
      }).catch(() => location.assign(root + 'cart'));
    }
  });
  document.addEventListener('click', event => {
    if (finished || resumingCheckout || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    settle().then(() => location.assign(link.href)).catch(() => location.assign(root + 'cart'));
  }, true);
  window.addEventListener('pageshow', event => {if (event.persisted && !finished) settle().catch(() => {});});
  window.emmaHalloweenGift = {endsAt: config.endsAt};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
})();
